let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bn6Qq")).then(() => parcelRequire('gpWGO'));